import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { Chip } from '@material-ui/core';

import MoneyFormat from './format/MoneyFormat.js';

import moment from 'moment';

import firebase from 'firebase/app';
require("firebase/firestore");

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

const styles = theme => ({
  textField: {
    width: 170,
  },
  marginRight: {
    marginRight: theme.spacing(2),
  },
})

class BuyPassDialog extends Component {
  state = {
    open: this.props.open,
    processing: false,

    branchId: this.props.branchId,
    selectedPass: '',
    paymentAmount: '',
    paymentMethod: '',
    staffRemark: '',
  };

  getSelectedPass = () => {
    return this.props.passes.find(pass => pass.id === this.state.selectedPass);
  }

  getSelectedPassRecord = () => {
    return this.props.userPass && this.props.userPass[this.state.selectedPass];
  }

  handleSubmit = () => {
    if (this.props.customer &&
      this.props.passes &&
      this.props.branches &&
      this.state.selectedPass &&
      this.state.branchId &&
      isNumeric(this.state.paymentAmount)) {

      this.startProcessing();
      this.submitPassAmendment()
        .then(this.submitPassTransaction)
        .then(this.stopProcessing)
        .then(this.handleRequestClose)
    }
  }

  submitPassTransaction = () => {
    return firebase.firestore()
      .collection('passTransaction')
      .where('userId', '==', this.props.customer.id)
      .where('passId', '==', this.state.selectedPass)
      .get()
      .then(qs => {
        return firebase.firestore()
          .collection('passTransaction')
          .add({
            branch: this.state.branchId,
            userId: this.props.customer.id,
            passId: this.state.selectedPass,
            adjustment: this.getSelectedPass().value,
            transactionDate: new Date(),
            paymentAmount: this.state.paymentAmount,
            paymentMethod: this.state.paymentMethod || "",
            staffRemark: this.state.staffRemark || "",
            isFirstTimeBuy: qs.empty,
          });
      });
  }

  submitPassAmendment = () => {
    const userPassRecordRef = firebase.firestore().collection('userPasses')

    const selectedPass = this.getSelectedPass();
    const selectedPassRecord = this.getSelectedPassRecord();

    switch (selectedPass.unit) {
      case 'time':
      case 'day':
        if (selectedPassRecord) {
          const data = {
            remaining: (selectedPassRecord.remaining || 0) + selectedPass.value
          };

          if (selectedPass.expiration) {
            const existExpiryDate = moment(selectedPassRecord.expiryDate && selectedPassRecord.expiryDate.toDate());
            const existRemaining = selectedPassRecord.remaining || 0;

            if (existExpiryDate.isBefore() || existRemaining === 0) {
              data.remaining = selectedPass.value;
              data.expiryDate = moment().add(selectedPass.expiration, 's').toDate();
            } else {
              data.expiryDate = existExpiryDate.add(selectedPass.expiration, 's').toDate();
            }
          }

          return userPassRecordRef.doc(selectedPassRecord.id).update(data);
        } else {
          const data = {
            userId: this.props.customer.id,
            passId: selectedPass.id,
            remaining: selectedPass.value
          };

          return userPassRecordRef.add(data);
        }
      case 'month':
        if (selectedPassRecord) {
          const existExpiryDate = moment(selectedPassRecord.expiryDate && selectedPassRecord.expiryDate.toDate());
          const newExpiryDate = (existExpiryDate.isBefore() ? moment() : existExpiryDate).add(selectedPass.value, 'M');
          return userPassRecordRef.doc(selectedPassRecord.id).update({
            expiryDate: newExpiryDate.toDate()
          });
        } else {
          return userPassRecordRef.add({
            userId: this.props.customer.id,
            passId: selectedPass.id,
            expiryDate: moment().add(selectedPass.value, 'M').toDate()
          });
        }
      default:
        return Promise.resolve();
    }
  }

  startProcessing = () => {
    this.setState({ processing: true });
  }

  stopProcessing = () => {
    this.setState({ processing: false });
  }

  handleRequestClose = () => {
    this.setState({ open: false });
    this.props.onRequestClose();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      if (nextProps.open) {
        this.setState({
          open: nextProps.open,
          branchId: this.props.branchId,
          selectedPass: '',
          paymentAmount: '',
          paymentMethod: '',
          staffRemark: '',
        });
      } else {
        this.setState({ open: nextProps.open, });
      }
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        onClose={this.handleRequestClose}
        open={this.state.open}>
        <DialogTitle>Buy Pass</DialogTitle>
        <DialogContent>
          <div>
            {/* Customer */}
            <Typography variant="h6" color="textSecondary">Customer</Typography>
            <div style={{ display: 'flex', flexWrap: 'wrap', }}>
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField} ${classes.marginRight}`}
                disabled
                label="Name"
                value={(this.props.customer && this.props.customer.name) || ''}
                margin="normal" />
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField} ${classes.marginRight}`}
                disabled
                label="Phone"
                value={(this.props.customer && this.props.customer.phone) || ''}
                margin="normal" />
              <TextField
                InputLabelProps={{ shrink: true, }}
                className={`${classes.textField}`}
                disabled
                label="Email"
                value={(this.props.customer && this.props.customer.email) || ''}
                margin="normal" />
            </div>
            <br />
            {/* Passes */}
            <Typography variant="h6" color="textSecondary">Passes</Typography>
            <div>
              <RadioGroup
                value={this.state.selectedPass}
                onChange={(event) => {
                  this.setState({
                    selectedPass: event.target.value,
                    paymentAmount: this.props.passes.find(element => { return element.id === event.target.value }).price,
                  })
                }}
              >
                {this.props.passes ?
                  this.props.passes.filter(pass => pass.active).map((pass, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        value={pass.id}
                        control={<Radio />}
                        label={
                          <div>
                            {pass.name}
                            {' '}
                            <Chip size='small' label={pass.branch} />
                            {' · '}
                            <MoneyFormat displayType='text' value={pass.price} />
                          </div>
                        }
                      />
                    );
                  }) : null
                }
              </RadioGroup>
            </div>
            <br />
            {/* Branch */}
            <Typography variant="h6" color="textSecondary">Branch</Typography>
            <FormControl
              disabled={this.props.branches && this.props.branches.find(branch => branch.id === this.props.branchId) !== undefined}>
              <Select
                className={`${classes.textField}`}
                value={this.state.branchId}
                onChange={event => {
                  this.setState({ branchId: event.target.value });
                }} >
                {this.props.branches.map(branch => (
                  <MenuItem key={branch.id} value={branch.id}>{branch.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <br />
            <br />
            <br />
            <Typography variant="h6" color="textSecondary">Payment</Typography>
            <FormControl
              margin="normal"
              className={`${classes.textField}`}>
              <InputLabel shrink>Payment Method</InputLabel>
              <Select
                value={this.state.paymentMethod}
                onChange={event => this.setState({ paymentMethod: event.target.value })}>
                <MenuItem value="cash">Cash</MenuItem>
                <MenuItem value="payme">PayMe</MenuItem>
                <MenuItem value="bank_transfer">Bank Transfer</MenuItem>
                <MenuItem value="octopus">Octopus</MenuItem>
                <MenuItem value="visa">Visa</MenuItem>
                <MenuItem value="master">Mastercard</MenuItem>
                <MenuItem value="ae">American Express</MenuItem>
                <MenuItem value="alipay">Alipay</MenuItem>
                <MenuItem value="wechat_pay">WeChat Pay</MenuItem>
              </Select>
            </FormControl>
            <br />
            <br />
            <FormControl>
              <InputLabel>Amount</InputLabel>
              <Input
                margin="normal"
                className={`${classes.textField}`}
                value={this.state.paymentAmount}
                inputComponent={MoneyFormat}
                onChange={event => {
                  let value = parseInt(event.target.value.replace(/\D/g, ''), 10);
                  this.setState({ paymentAmount: isNumeric(value) ? value : '' });
                }}
              />
            </FormControl>
            <br />
            <br />
            <br />
            <Typography variant="h6" color="textSecondary">Staff Remark</Typography>
            <FormControl>
              <InputLabel>Who are you?</InputLabel>
              <Input
                className={`${classes.textField}`}
                value={this.state.staffRemark}
                onChange={event => this.setState({ staffRemark: event.target.value })}
              />
            </FormControl>

          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleRequestClose} >Close</Button>
          <Button
            disabled={
              this.state.processing ||
              !this.state.selectedPass ||
              !(this.props.branches && this.props.branches.find(branch => branch.id === this.state.branchId)) ||
              !isNumeric(this.state.paymentAmount) ||
              !this.state.paymentMethod
            }
            onClick={this.handleSubmit}
            color="primary">
            SUBMIT
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

BuyPassDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  customer: PropTypes.object,
  passes: PropTypes.array.isRequired,
  userPass: PropTypes.object,
  branches: PropTypes.array.isRequired,
  branchId: PropTypes.string,
};

export default withStyles(styles)(BuyPassDialog);
